module.exports = __webpack_public_path__ + "img/false-positives.ba351e7.webp";